export default "__VITE_ASSET__0f7bef51__"